import React from "react";
import { Helmet } from "react-helmet";
import { snackbar } from "@mobiscroll/react5";
import fileToBase64 from "src/lib/fileToBase64";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";

import "./Profile.scss";

import Loader from "src/components/Dashboard/common/Loader";
import { getMyProfile, updateProfile } from "./api";
import { useDispatch, useSelector } from "react-redux";
import { storeUser } from "src/features/user/userSlice";

const Profile = () => {
  const [data, setData] = React.useState(null);
  const [edit, setEdit] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  const [edited, setEdited] = React.useState(null);
  const [touched, setTouched] = React.useState({});

  const dispatch = useDispatch();
  const userData = useSelector(state => state?.user?.user || null);

  const reloadData = async () => {
    setLoader(true);
    try {
      const response = await getMyProfile();
      if (response) {
        dispatch(storeUser(response))
        snackbar({ message: "Doctor details is updated Successfully.", color: "success", });
      } else {
        snackbar({ message: "Please add fee policy from Fee section for getting started.", color: "success", });
      }
    } catch (error) {
      console.error("Error at fetching user", error);
    } finally {
      setLoader(false);
    }
  };

  React.useEffect(() => {
    if (userData != null) {
      setData(userData);
    }
  }, [userData]);

  const cancelOnClick = React.useCallback((e) => {
    e.preventDefault();
    setEdited(null);
    setEdit(false);
  }, []);

  const editOnClick = React.useCallback((e) => {
    e.preventDefault();
    setEdited(data);
    setEdit(true);
  }, [data]);

  const saveOnClick = React.useCallback(
    async (e) => {
      setLoader(true);
      e.preventDefault();
      let _data = { id: data.id, };

      Object.keys(edited).map((item) => {
        if (touched[item]) {
          _data[item] = edited[item];
        }
      });

      if (typeof _data.award === 'string' && _data.award.trim() === "") {
        _data.award = 0;
      }

      const res = await updateProfile(_data);
      if (res) {
        reloadData()
      }
      setEdited(null);
      setTouched({});
      setEdit(false);
      setLoader(false);
    },
    [data, edited]
  );

  function _renderAction() {
    return (
      <React.Fragment>
        <div className="form-statusbar">
          {edit ? (
            <React.Fragment>
              <div className="d-flex">
                <button className="docg-save-btn" onClick={saveOnClick}>
                  Save
                </button>
                <button className="docg-save-btn bg-purple" onClick={cancelOnClick} style={{ marginLeft: "8px" }}>
                  Cancel
                </button>
              </div>
            </React.Fragment>
          ) : (
            <button className="docg-save-btn" onClick={editOnClick}>
              Edit
            </button>
          )}
        </div>
      </React.Fragment>
    );
  }

  const handleChange = (e) => {
    setEdited((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
    setTouched((prev) => {
      return { ...prev, [e.target.name]: true };
    });
  };

  const handleImageChange = React.useCallback(
    (keyword, e) => {
      setLoader(true);
      try {
        if (e.target.files[0]) {
          let file = e.target.files[0];
          fileToBase64(file)
            .then(async (result) => {
              file["base64"] = result;
              const res = await updateProfile({ id: data.id, [keyword]: result.split(",")[1], });
              console.log("update response--- >", res);
              if (res) {
                reloadData()
              }

              const doctorVerified = sessionStorage.getItem("doctorVerified");
              if (keyword == "signature" && doctorVerified == "false") {
                sessionStorage.setItem("doctorVerified", userData?.doctorVerified);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      } catch (err) {
        console.error(err);
      }
      setLoader(false);
    },
    [data]
  );

  const handleImageUpload = React.useCallback(
    async (keyword, file) => {
      setLoader(true);
      try {
        const res = await updateProfile({ id: data.id, [keyword]: file.split(",")[1], });
        if (res) {
          reloadData()
        }

        const doctorVerified = sessionStorage.getItem("doctorVerified");
        if (keyword === "signature" && doctorVerified === "false") {
          sessionStorage.setItem("doctorVerified", userData?.doctorVerified);
        }
      } catch (err) {
        console.error(err);
      }
      setLoader(false);
    },
    [data]
  );

  return (
    <>
      <Helmet>
        <title>Profile | DOCG</title>
      </Helmet>
      <Loader show={loader} />
      <div className=" mbsc-col-12 mbsc-col-md-4 mbsc-col-lg-3">
        <LeftPanel
          edit={edit}
          setEdit={setEdit}
          data={data}
          setData={setData}
          edited={edited}
          setEdited={setEdited}
          setTouched={setTouched}
          cancelOnClick={cancelOnClick}
          editOnClick={editOnClick}
          _renderAction={_renderAction}
          handleChange={handleChange}
          handleProfileChange={handleImageChange}
          handleImageUpload={handleImageUpload}
          reloadData={reloadData}
        />
      </div>
      <div className="mbsc-col-lg-9 mbsc-col-md-8 mbsc-col-12">
        <RightPanel
          edit={edit}
          setEdit={setEdit}
          data={data}
          setData={setData}
          edited={edited}
          setEdited={setEdited}
          setTouched={setTouched}
          cancelOnClick={cancelOnClick}
          editOnClick={editOnClick}
          _renderAction={_renderAction}
          handleChange={handleChange}
          handleImageChange={handleImageChange}
        />
      </div>
    </>
  );
};

export default Profile;
